export const TOKEN_KEY = "SeparationsInfo";

export interface Separations {
    valueCd: string
}

export const getSeparationsStorage = (): Separations => {
  const json: any = localStorage.getItem(TOKEN_KEY);
  const obj: Separations = JSON.parse(json);
  return obj || '';
};

export const setSeparationsStorage = (cd: Separations) => {
  let jsonAux: any = JSON.stringify(cd);
  localStorage.setItem(TOKEN_KEY, jsonAux);
};

export const deleteSeparations = () => {
  localStorage.removeItem(TOKEN_KEY);
};
